import { createAsyncThunk } from "@reduxjs/toolkit";
import { API } from "app/auth/base";
import { closeLoading, openLoading } from "app/store/trackingApp/loadingSlice";
import { openToast } from "app/store/trackingApp/toastSlice";
import { openModalError } from "app/store/trackingApp/modalErrorSlice";

export const getApelidos = createAsyncThunk(
  "transportadorasApp/apelidos/getApelidos",
  async (data: object, { dispatch }) => {
    let response;
    dispatch(openLoading());
    try {
      response = await API.get("/transportadoraapelidos", { params: data });
    } catch (err: any) {
      dispatch(
        openModalError({
          title: "Não foi possível buscar os apelidos!",
          text: "Se certifique que os dados digitados estão corretos",
          btnLabel: "Voltar",
        })
      );
      console.error(err.response);
    }
    dispatch(closeLoading());
    return response.data;
  }
);

export const saveApelido = createAsyncThunk(
  "transportadorasApp/apelidos/saveApelido",
  async (data: object, { dispatch, getState }) => {
    const requestGetParams: any = getState();
    try {
      await API.post("/transportadoraapelidos", data);
      dispatch(
        openToast({
          severity: "success",
          title: "Apelido cadastrado",
        })
      );
      dispatch(
        getApelidos(
          requestGetParams.transportadorasApp.apelidos.requestGetParams
        )
      );
    } catch (err: any) {
      dispatch(
        openModalError({
          title: "Não foi possível cadastrar o apelido!",
          text: "Se certifique que os dados digitados estão corretos",
          btnLabel: "Voltar",
        })
      );
      console.error(err.response);
    }
    return {};
  }
);

export const editApelido = createAsyncThunk(
  "transportadorasApp/apelidos/editApelido",
  async (data: object, { dispatch, getState }) => {
    const requestGetParams: any = getState();
    try {
      await API.put("/transportadoraapelidos", data);
      dispatch(
        openToast({
          severity: "success",
          title: "Apelido editado",
        })
      );
      dispatch(
        getApelidos(
          requestGetParams.transportadorasApp.apelidos.requestGetParams
        )
      );
    } catch (err: any) {
      dispatch(
        openModalError({
          title: "Não foi possível editar o apelido!",
          text: "Se certifique que os dados digitados estão corretos",
          btnLabel: "Voltar",
        })
      );
      console.error(err.response);
    }
    return {};
  }
);

export const deleteApelido = createAsyncThunk(
  "transportadorasApp/apelidos/deleteApelido",
  async (data: any, { dispatch, getState }) => {
    const requestGetParams: any = getState();
    const { idApelido } = data;
    try {
      await API.delete(`/transportadoraapelidos/${idApelido}`);
      dispatch(
        openToast({
          severity: "success",
          title: "Apelido removido",
        })
      );
      dispatch(
        getApelidos(
          requestGetParams.transportadorasApp.apelidos.requestGetParams
        )
      );
    } catch (err: any) {
      dispatch(
        openModalError({
          title: "Não foi possível remover o apelido!",
          text: "Se certifique que a solicitação está correta",
          btnLabel: "Voltar",
        })
      );
      console.error(err.response);
    }
    return {};
  }
);
